export default __webpack_public_path__ + "static/media/that which takes care of us.d88789b9.jpg";